export default {
  "content": "<path d=\"M12.5 13.5h-3v-2h3v2z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.531 7.015A2.75 2.75 0 0123 9.75v8.5A2.75 2.75 0 0120.25 21H7.75A2.75 2.75 0 015 18.25v-8.5A2.75 2.75 0 017.75 7h12.5l.281.015zM7.75 9a.75.75 0 00-.75.75v8.5c0 .414.336.75.75.75h12.5a.75.75 0 00.75-.75v-8.5a.75.75 0 00-.673-.746L20.25 9H7.75z\" fill=\"#7B61FF\"/><path d=\"M18 5H3.75a.75.75 0 00-.75.75V16H1V5.75A2.75 2.75 0 013.75 3H18v2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};